import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useRef, useState } from 'react';
import Div from '../Page/Div';
import { Link } from 'react-router-dom';
import FixedContainer from '../Page/FixedContainer';
import { WPImage } from '../UI/WPImage';
import ImageContainer from '../UI/ImageContainer';
import { isMobileWidth, linkToText, MOBILE_SAFE_RESIZE } from '../globalUtils';
const HomeSectorsSection = ({ content, idx, allowOpen, }) => {
    const [mobileView, setMobileView] = useState(isMobileWidth());
    const mobileViewRef = useRef(mobileView);
    mobileViewRef.current = mobileView;
    useEffect(() => {
        window.addEventListener(MOBILE_SAFE_RESIZE, onResize);
        onResize();
        return () => {
            window.removeEventListener(MOBILE_SAFE_RESIZE, onResize);
        };
    }, []);
    const onResize = () => {
        const mobile = isMobileWidth();
        if (mobile && !mobileViewRef.current) {
            setMobileView(true);
        }
        if (!mobile && mobileViewRef.current) {
            setMobileView(false);
        }
    };
    const { title, details_1, details_2, button, images } = content?.home_page_sectors ?? {};
    const sortedImages = (images ?? []).sort((a, b) => a.depth < b.depth ? -1 : 1);
    return (_jsx(FixedContainer, { blocked: !content.force_snap, idx: idx, allowOpen: allowOpen, parentClassName: `home-sectors-container`, sliderClassName: `home-sectors-wrapper`, children: [
            title ? (_jsx(Div, { blocked: !allowOpen, className: "home-sectors-title", delay: 0, noScale: true, children: title }, "0")) : null,
            details_1 ? (_jsx(Div, { blocked: !allowOpen, className: "home-sectors-details", delay: 1, noScale: true, children: details_1 }, "1")) : null,
            details_2 ? (_jsx(Div, { blocked: !allowOpen, className: "home-sectors-details", delay: 2, noScale: true, children: details_2 }, "2")) : null,
            button?.url ? (_jsx(Div, { blocked: !allowOpen, className: "home-sectors-button", delay: 3, noScale: true, children: _jsx(Link, { to: button.url, "aria-label": `Visit ${linkToText(button.url)}`, children: _jsx("div", { className: "button", children: button.title }) }) }, "3")) : null,
            _jsx(Div, { blocked: !allowOpen, className: "home-sectors-images", delay: button?.url ? 4 : 2, noScale: true, children: sortedImages.map((item, idx) => {
                    const { position, position_mobile, image, link, depth } = item;
                    const pos = mobileView ? position_mobile || position : position;
                    return (_jsx(ImageContainer, { setup: pos, allowOpen: allowOpen, delay: 3 + idx * 0.5 + idx * 0.5 * Math.random(), depth: parseFloat(depth ?? '0'), children: _jsx(Link, { to: link, "aria-label": `Visit ${linkToText(link)}`, children: _jsx(WPImage, { className: "home-sector-image", id: image }) }) }, image));
                }) }, "4"),
        ] }));
};
export default HomeSectorsSection;
